<template>
  <!--     <a-list-item>
        <a slot="actions">
            Edit
        </a>
        <a slot="actions">
            Delete
        </a>
        <a-list-item-meta :description="productCategory">
            <a slot="title"> 
                {{ productName }} 
            </a>
        </a-list-item-meta>
    </a-list-item> -->

  <div class="list-card">
    <div>
      <img
        v-if="productImage != null && productImage != ''"
        :src="productImage"
      />
      <img slot="cover" v-else src="@/assets/images/productblank.png" />
    </div>
    <div>
      <div class="item-meta">
        <h3 class="list-item-title">{{ productName }}</h3>
        <div class="quantity-price">
          <span>{{ productPrice }} kr</span>
          <div class="quantity-btns">
            <a-icon
              @click="decrement"
              type="minus-square"
              :style="{ fontSize: '18px' }"
            />
            <span>{{ count }}</span>
            <a-icon
              @click="increment"
              type="plus-square"
              :style="{ fontSize: '18px', color: '#08c' }"
            />
          </div>
        </div>
      </div>
      <div class="item-actions">
        <button>Edit</button>
        <button>Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productId: {
      type: String,
      //required : true
    },
    productName: {
      type: String,
      //required : true
    },
    productPrice: {
      type: Number,
    },
    productCategory: {
      type: String,
      //required : true
    },
    productImage: {
      type: String,
      //required: true
    },
    productTax: {
      type: Number,
      //required : true
    },
  },
  data() {
    return {
      count: 1,
    };
  },
  computed: {
    getPrice() {
      return this.itemPrice + ' kr';
    },
  },
  methods: {
    increment() {
      if (this.count < 50) {
        this.count++;
      }
    },
    decrement() {
      if (this.count > 1) {
        this.count--;
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.quantity-price {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.quantity-btns > .anticon {
  margin: 0 8px;
}
.item-actions > button {
  border-radius: 5px;
  outline: none;
  color: #016dc0;
  border: 1px solid #dde3e7;
  margin-right: 5px;
}
.list-card {
  display: flex;
  align-items: center;

  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  border-radius: 10px;
  margin-top: 10px;

  & img {
    width: 9rem;
    margin: 5px;
    border-radius: 10px;
  }
}

.list-item-title {
  font-size: 1rem;
}

.item-meta {
  margin-right: 5px;

  & p {
    margin-bottom: 0;
  }
}
</style>
